import {
  createProfileUrl,
  retrieveProfileByTokenUrl,
  getProfilesUrl,
  getClientAreaProfilesUrl,
  retrieveClientAreaProfileByUserIdUrl,
  retrieveProfileByUserIdUrl,
  supervisorUrl,
  deleteUserUrl,
  patchUserUrl,
} from '../constants/endpointUrls';

import Service from './Service';

class UserService extends Service {
  createProfile(
    partner,
    departureDate,
    entryDate,
    monthlyBonus,
    monthlyGoal,
    name,
    referenceCode,
    salary,
    userId,
    state,
    zone
  ) {
    const params = {
      partner,
      departureDate,
      entryDate,
      monthlyBonus,
      monthlyGoal,
      name,
      referenceCode,
      salary,
      userId,
      state,
      zone,
    };

    return this.postRequest(createProfileUrl(userId), params);
  }

  getProfileByToken(token) {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    return this.getRequest(retrieveProfileByTokenUrl, undefined, config);
  }

  getSupervisor() {
    return this.getRequest(supervisorUrl());
  }

  getProfiles(page = 0) {
    const params = {
      page,
    };

    return this.getRequest(getProfilesUrl, params);
  }

  updateProfiles(userId) {
    const params = {
      userId,
    };

    return this.patchRequest(getProfilesUrl, params);
  }

  getClientAreaProfiles(filter = {}, page = 0) {
    const params = {
      ...filter,
      page,
    };

    return this.getRequest(getClientAreaProfilesUrl, params);
  }

  getProfileByUserId(userId) {
    return this.getRequest(retrieveProfileByUserIdUrl(userId));
  }

  getClientAreaProfileByUserId(userId) {
    return this.getRequest(retrieveClientAreaProfileByUserIdUrl(userId));
  }

  deleteProfileById(userId) {
    return this.deleteRequestAuth(deleteUserUrl(userId));
  }

  patchUsers(userId, params) {
    return this.patchRequest(patchUserUrl(userId), params);
  }
}

export default new UserService();



// WEBPACK FOOTER //
// ./src/utils/services/UserService.js